module.exports = __webpack_public_path__ + "img/violet.16128357.png";